import { SimpleSelect } from '@aloft/toolkit-sui';

import { useZodFormContext } from '../../hooks/useZodForm.ts';

export function RoundingSelect({ fieldPath }: { fieldPath: string }) {
  const { register } = useZodFormContext();
  return (
    <SimpleSelect size="sm" {...register(fieldPath)}>
      <option value="1">To the nearest whole dollar</option>
      <option value="100">To the nearest $100</option>
      <option value="500">To the nearest $500</option>
      <option value="1000">To the nearest $1,000</option>
      <option value="5000">To the nearest $5,000</option>
      <option value="10000">To the nearest $10,000</option>
    </SimpleSelect>
  );
}
